/* global AirDatepicker */

export default class DatePicker {
	constructor(checkInEl = null, checkOutEl = null) {
		if ( checkInEl && checkOutEl) {
			this.checkInEl = checkInEl;
			this.checkOutEl = checkOutEl;

			this.checkInGroup = document.getElementById('checkin-group');
			this.checkOutGroup = document.getElementById('checkout-group');

			this.checkInDay = this.checkInGroup.querySelector('.day');
			this.checkInMonth = this.checkInGroup.querySelector('.month .name');
			this.checkOutDay = this.checkOutGroup.querySelector('.day');
			this.checkOutMonth = this.checkOutGroup.querySelector('.month .name');

			let checkIn, checkOut;
			const defaultCheckin = new Date();
			const defaultCheckout = new Date();
			defaultCheckout.setDate(defaultCheckout.getDate() + 3);
			const theClass = this;

			const localeEn = {
				days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
				daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
				months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				today: 'Today',
				clear: 'Clear',
				dateFormat: 'MM/dd/yyyy',
				timeFormat: 'hh:mm aa',
				firstDay: 0
			};

			checkIn = new AirDatepicker( this.checkInEl, {
				locale: localeEn,
				dateFormat: 'dd/MM/yyyy',
				selectedDates: [defaultCheckin],
				minDate: defaultCheckin,
				isMobile: window.innerWidth < 768,
				autoClose: true,
				onSelect({date}) {
					theClass.changeDateLabels.bind(theClass)('checkin', date);
					checkOut.update({
						minDate: date
					});
				}
			});

			checkOut = new AirDatepicker( this.checkOutEl, {
				locale: localeEn,
				dateFormat: 'dd/MM/yyyy',
				selectedDates: [defaultCheckout],
				isMobile: window.innerWidth < 768,
				autoClose: true,
				onSelect({date}) {
					theClass.changeDateLabels.bind(theClass)('checkout', date);
					checkIn.update({
						maxDate: date
					})
				}
			});

			this.init();

		}
	}

	init() {
		this.changeDateLabels('checkin', new Date());

		let checkoutdate = new Date();
		checkoutdate.setDate(checkoutdate.getDate() + 3);
		this.changeDateLabels('checkout', checkoutdate);
	}

	changeDateLabels(type = '', date = null) {
		if (!date) return;
		const dateOptions = { month: 'short' };

		if ('checkin' === type) {
			this.checkInDay.innerText = date.getDate().toString();
			this.checkInMonth.innerText = date.toLocaleString( 'en-US', dateOptions );
		} else if ('checkout' === type) {
			this.checkOutDay.innerText = date.getDate().toString();
			this.checkOutMonth.innerText = date.toLocaleString( 'en-US', dateOptions );
		}
	}
}
